import { createFileRoute } from '@tanstack/react-router'
import { CacheMetricsDashboard } from '@/features/cache'

export const Route = createFileRoute('/_authenticated/cache-metrics')({
  component: CacheMetricsPage,
})

function CacheMetricsPage() {
  return (
    <div className='flex flex-1 flex-col gap-4 p-4 md:gap-8 md:p-8'>
      <CacheMetricsDashboard />
    </div>
  )
}
